import React from "react"
import ViewSwitch from "./ViewSwitch"
import { useNavigate, useLocation } from "react-router-dom"
import classNames from "utils/classNames"

const VendorViewSwitch = ({ className }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const path = location.pathname
  const handleClick = type => {
    if (path.includes("map") && type === "map") {
      return
    } else {
      if (type === "map") {
        navigate(`/d/registration/vendors/map${location.search}`)
      } else {
        navigate(`/d/registration/vendors${location.search}`)
      }
    }
  }

  return (
    <ViewSwitch
      active={path.includes("map") ? "map" : "list"}
      className={classNames(className)}
      onClick={handleClick}
    />
  )
}

export default VendorViewSwitch
